import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import Popover from "antd/lib/popover";
import Tooltip from "antd/lib/tooltip";
import Image from "antd/lib/image";
import Rate from "antd/lib/rate";
import CarouselWidgetMaker from "./Carousel";
import Profile from "../../assets/Profile_Pic.svg";
import defaultImg from "../../assets/WidgetMaker/Brocken_Image.svg";
import Default_Brand from "../../assets/brandLogos/Default_Brand.svg";
import ClockIcon from "../../assets/Clock.svg";
import verified from "../../assets/verified.svg";
import androidImage from "../../assets/android_icon_image.svg";
import somethingWentWrong from "../../assets/No_Data_Found.svg";
import isEqual from "react-fast-compare";
import { SocialMedialogo } from "../layout/DeepDive/DeepDivetab/SocialMediaPlatforms";
import PaginationComponent from "./PaginationComponent";
import SortBy from "./SortBy";
import deepLinkIcon from "../../assets/deepLink_Icon.svg";
import Modal from "antd/lib/modal";
import config1 from "../../config";
import PostCardDetails from "./PostCardDetails";
import PostCardFilters from "./PostCardFilters";
import {
  formatTextForDirection,
  getPaneIndex,
  getTextDirection,
  getTextWithWrapHtml,
  getWindowLocationPath,
} from "../../redux/constants";
import { MentionIdComponent } from "./MentionIdComponent";
import { sentimentClass } from "../../redux/constants/enums";

const ReviewCard = ({
  data,
  filterPills,
  totalPageNo,
  metadata,
  section_index,
  widget_index,
  mentionPage,
  pagination,
  isPreviewState,
  dashboard,
  PdfDownloadStatus,
  PptGeneratingStatus,
  noteExist,
  chart_type,
  deepDive,
  widget_id,
  highlightWord,
}) => {
  const authParams = useSelector((state) => state.Authentication.authParams);
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const shareBrands = useSelector((state) => state?.ApiCall?.shareBrands);
  const shareableLinkDeepDiveStatus = useSelector(
    (state) => state?.ApiCall?.shareableLinkDeepDiveStatus
  );
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const screen = useSelector((state) => state?.Screens?.screen);
  const deepdiveDashboardTemplateData = useSelector(
    (state) => state?.DeepDiveDashboard?.dashboardTemplateData
  );
  let currentPath = window.location.pathname;
  let splitPath = currentPath.split("/");
  const isshowSideBar = useSelector((state) => state.WidgetMaker.isshowSideBar);
  const [deepLinkModal, setDeepLinkModal] = useState({
    url: null,
    modalShow: false,
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setIsModalData] = useState(null);
  const [isModalLoader, setIsModalLoader] = useState(false);
  const onExternal = (TicketID, PostBrandID) => {
    setDeepLinkModal({
      url: null,
      modalShow: true,
    });
    let url =
      config1?.config1?.app_id === "10" || config1?.config1?.app_id === 10
        ? "https://preprodcx.locobuzz.com/ticketDetail"
        : config1?.config1?.app_id === "6" || config1?.config1?.app_id === 6
        ? window?.location?.origin?.includes("bbps.locobuzz.com") ||
          window?.location?.ancestorOrigins?.[0]?.includes("bbps.locobuzz.com")
          ? "https://bbps.locobuzz.com/ticketDetail"
          : "https://cx.locobuzz.com/ticketDetail"
        : config1?.config1?.app_id === "4" || config1?.config1?.app_id === 4
        ? window?.location?.origin?.includes("demo.locobuzz.com")
          ? "https://demo.locobuzz.com/ticketDetail"
          : window?.location?.origin?.includes(
              "locobuzzng-uat-aws.locobuzz.com"
            ) ||
            window?.location?.ancestorOrigins?.[0]?.includes(
              "locobuzzng-uat-aws.locobuzz.com"
            )
          ? "https://locobuzzng-uat-aws.locobuzz.com/ticketDetail"
          : "https://demo.locobuzz.com/ticketDetail"
        : "https://demo.locobuzz.com/ticketDetail";
    // : "https://demo.locobuzz.com/ticketDetail";

    let finalUrl = `${url}/${TicketID}/${PostBrandID}`;
    if (config1?.config1?.app_id === "2") {
      console.log("Deep Link URL =>", finalUrl);
    }
    // window.open(finalUrl);

    setDeepLinkModal({
      url: (
        <iframe
          title="Ticket Details"
          allowfullscreen={true}
          src={finalUrl}
          alt="Ticket Details"
          className="w-100 border-0 border-radius-4"
          style={{ height: "calc(100vh - 6.3rem)", marginTop: "3.7rem" }}
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
        />
      ),
      modalShow: true,
    });
  };
  const handleDeepLinkOk = () => {
    setDeepLinkModal({
      url: null,
      modalShow: false,
    });
  };
  const handleDeepLinkCancel = () => {
    setDeepLinkModal({
      url: null,
      modalShow: false,
    });
  };
  const showModal = (data) => {
    setIsModalLoader(true);
    setIsModalOpen(true);
    setIsModalData(data);
  };
  const isDeepDiveDashboardView = useMemo(() => {
    let pathName = getWindowLocationPath()?.toLowerCase();
    return (
      (authParams?.screen_id
        ? screen?.isDeepDiveDashboard
          ? true
          : false
        : shareableLinkDeepDiveStatus
        ? shareTemplateData?.isDeepDiveDashboard
          ? true
          : false
        : !authParams?.screen_id &&
          !shareBrands &&
          (pathName === "dashboard" || pathName === "pin-dashboard") &&
          !panes?.[getPaneIndex(panes, activeKey)]?.is_widget_maker_open_obj
            ?.open_flag &&
          panes?.[getPaneIndex(panes, activeKey)]?.isDeepDiveDashboard
        ? true
        : false) && !deepdiveDashboardTemplateData?.isDeepDive
    );
  }, [
    screen,
    shareTemplateData,
    panes,
    authParams,
    deepdiveDashboardTemplateData,
  ]);
  return (
    <>
      <PostCardFilters
        filterPills={filterPills}
        metadata={metadata}
        section_index={section_index}
        widget_index={widget_index}
        deepDive={deepDive}
        isPreviewState={isPreviewState}
        PdfDownloadStatus={PdfDownloadStatus}
        PptGeneratingStatus={PptGeneratingStatus}
        widget_id={widget_id}
        chart_type={chart_type}
        isDeepDiveDashboardView={isDeepDiveDashboardView}
      />
      {deepDive ||
      splitPath[1] === "widgetMaker" ||
      splitPath[1] === "edit-widget" ? (
        <div
          id={`post_card_${section_index ? section_index : "section_index"}_${
            widget_index ? widget_index : "widget_index"
          }`}
          className={`w-100 wm-chart-cards text-right`}
        >
          <SortBy
            metadata={metadata}
            section_index={section_index}
            widget_index={widget_index}
            isPreviewState={isPreviewState}
            PdfDownloadStatus={PdfDownloadStatus}
            PptGeneratingStatus={PptGeneratingStatus}
            chart_type={chart_type}
            dashboard={dashboard}
            deepDive={deepDive}
            widget_id={widget_id}
            isDeepDiveDashboardView={isDeepDiveDashboardView}
          />
        </div>
      ) : (
        <></>
      )}
      {data?.length > 0 ? (
        <div
          className={`row mr-0 ml-0 pr-15 ${
            splitPath[1] !== "widgetMaker" && splitPath[1] !== "edit-widget"
              ? PdfDownloadStatus || PptGeneratingStatus
                ? "pt-15"
                : "mt-15"
              : PdfDownloadStatus || PptGeneratingStatus
              ? "pt-15"
              : ""
          }`}
        >
          {data?.map((el, i) => {
            if (
              (PdfDownloadStatus || PptGeneratingStatus) &&
              noteExist &&
              i > 2
            )
              return null;
            if ((PdfDownloadStatus || PptGeneratingStatus) && i > 5)
              return null;
            let postTextDirection = getTextDirection(el?.PostText || "");
            return (
              <div
                key={`${el?.TagID}_${i}`}
                className={`col-12 col-md-6 ${
                  isPreviewState
                    ? "col-lg-6"
                    : isshowSideBar || mentionPage
                    ? "col-lg-4"
                    : !dashboard
                    ? "col-lg-6"
                    : "col-lg-4 col-xl-4"
                } pr-0`}
              >
                <div
                  className={`postcard-class-for-mention card cardList border-color mb-2 text-left ${
                    sentimentClass[el.SentimentType]
                  }`}
                >
                  <MentionIdComponent
                    color={el?.SentimentType}
                    id={el?.mention_id}
                  />
                  <div
                    className={`cardList-head p-15 pb-0 mt-0 card-head text_heading d-flex align-items-center justify-content-between ${
                      el?.SentimentType ? " pl-0 pdf__pl--0" : ""
                    } ${el?.IsDeletedFromSocial ? " pr-0 pdf__pr--0" : ""}`}
                  >
                    <div
                      className="d-flex align-items-center"
                      style={{ width: "60%" }}
                    >
                      {el?.SentimentType ? (
                        <div
                          style={{
                            borderLeft: `0.4rem solid ${
                              el?.SentimentType === "Positive"
                                ? "#5ED142"
                                : el?.SentimentType === "Negative"
                                ? "#FF5D48"
                                : el?.SentimentType === "Neutral"
                                ? "#F0C52F"
                                : "black"
                            }`,
                            height: "3.6rem",
                            marginRight: "1rem",
                          }}
                        ></div>
                      ) : (
                        ""
                      )}
                      <div
                        className="position-relative mr-15"
                        style={{ width: "3.5rem" }}
                      >
                        {!PdfDownloadStatus && !PptGeneratingStatus ? (
                          <Popover
                            placement="leftBottom"
                            title={null}
                            content={
                              el?.AuthorBio && (
                                <div
                                  style={{ maxWidth: "25rem" }}
                                  className="text_regular fontSize-12 p-15"
                                >
                                  {el?.AuthorBio}
                                </div>
                              )
                            }
                            overlayClassName={
                              authParams?.theme_type === "1"
                                ? "darkTheme"
                                : "lightTheme"
                            }
                          >
                            <Image
                              src={
                                el?.ProfilePicture === 0 ||
                                el?.ProfilePicture === "" ||
                                !el?.ProfilePicture
                                  ? Profile
                                  : el?.ProfilePicture
                              }
                              fallback={Profile}
                              preview={false}
                              alt="Profile Images"
                              className="profileImg m-0 cursor-pointer"
                              style={{ width: "3.5rem", height: "3.5rem" }}
                            />
                          </Popover>
                        ) : (
                          <Image
                            src={
                              PdfDownloadStatus
                                ? el?.ProfilePicture === 0 ||
                                  el?.ProfilePicture === "" ||
                                  !el?.ProfilePicture
                                  ? Profile
                                  : el?.ProfilePicture
                                : Profile
                            }
                            fallback={Profile}
                            preview={false}
                            alt="Profile Images"
                            className="profileImg m-0 cursor-pointer"
                            style={{ width: "3.5rem", height: "3.5rem" }}
                          />
                        )}
                        <div
                          className="position-absolute"
                          style={{ right: "-0.8rem", top: "-0.4rem" }}
                        >
                          <Image
                            src={
                              el?.PlatformID === 0
                                ? Default_Brand
                                : SocialMedialogo?.[el?.PlatformID]
                                ? SocialMedialogo?.[el?.PlatformID]
                                : Default_Brand
                            }
                            alt="Channel"
                            preview={false}
                            fallback={Default_Brand}
                            style={{
                              maxWidth: "1.6rem",
                              maxHeight: "2rem",
                              verticalAlign: "top",
                            }}
                            className="mr-0"
                          />
                        </div>
                      </div>
                      <div className="d-flex flex-wrap align-items-center w-100">
                        <div className="profileName line-height-normal">
                          {el?.AuthorName}
                        </div>
                        {el?.AuthorIsVerified !== "NA" &&
                        el?.AuthorIsVerified &&
                        el?.AuthorIsVerified > 0 ? (
                          <img
                            src={verified}
                            alt="verified"
                            className="profileImg ml-1"
                            style={{ width: "1.5rem" }}
                          />
                        ) : (
                          ""
                        )}
                        {el?.AuthorScreenName &&
                        el?.PlatformID !== 2 &&
                        el?.PlatformID !== 5 ? (
                          <div className="screenName">
                            {el?.AuthorScreenName}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <span
                      className="font-size12 align-items-center d-flex justify-content-end"
                      style={{ width: "40%" }}
                    >
                      <Tooltip
                        title={
                          <div>
                            Created Date : <br />{" "}
                            {el?.CreatedDate
                              ? el?.CreatedDate
                              : el?.PostCreatedDate}
                          </div>
                        }
                        className="no--wrap"
                      >
                        <img
                          src={ClockIcon}
                          className="cardList__footer-label"
                          alt="Clock Icon"
                        />
                        <span className="cardList__footer-count line-height-normal">
                          {el?.CreatedDate
                            ? moment(el?.CreatedDate)?.format("DD MMM YYYY")
                            : moment(el?.PostCreatedDate)?.format(
                                "DD MMM YYYY"
                              )}
                        </span>
                      </Tooltip>
                      {el?.IsDeletedFromSocial ? (
                        <Tooltip
                          title={<div>Deleted From Social</div>}
                          placement="topRight"
                          className="no--wrap"
                        >
                          <span
                            className={`deletedFromSocialIcon ${"d-flex align-items-center"} `}
                          >
                            <i className="fas fa-trash-alt trash__icon"></i>
                          </span>
                        </Tooltip>
                      ) : (
                        ""
                      )}
                    </span>
                  </div>
                  <div className="card-body p-0">
                    <div className="mb-2 pl-15 d-flex justify-content-between pr-15">
                      {((el?.PlatformID !== 2 && el?.Rating === 0) ||
                        el?.Rating > 0) && (
                        <>
                          <span className="mr-15 d-flex align-items-center">
                            <Rate
                              disabled
                              value={el?.Rating ? el?.Rating : el?.rating}
                              className="no--wrap w-100 ratingList mr-1"
                            />
                            {el?.Rating}
                          </span>
                          {el?.card_type === "User Post" &&
                            el?.PlatformID === 7 && (
                              <span className="mr-15 d-flex align-items-center">
                                <span
                                  className="w-100 text-ellipsis mr-1"
                                  style={{ color: "blue" }}
                                >
                                  App Version:
                                </span>
                                {el?.App_version === "NA" ? (
                                  <>
                                    <i
                                      className={`fa fa-minus cursor-pointer ml-1 fontSize-12 ${
                                        window.location.pathname
                                          .toLowerCase()
                                          ?.includes("/commandcenter/screens")
                                          ? "dynamic_icon_color"
                                          : "text-gray"
                                      }`}
                                    />
                                    <Tooltip
                                      title="Version information is not available for this review."
                                      placement="top"
                                      className="text-ellipsis d-inline-block wm-chart-card-title"
                                    >
                                      <i
                                        className={`fa fa-info-circle cursor-pointer ml-1 ${
                                          window.location.pathname
                                            .toLowerCase()
                                            ?.includes("/commandcenter/screens")
                                            ? "dynamic_icon_color"
                                            : "text-gray"
                                        }`}
                                        style={{ overflow: "visible" }}
                                      />
                                    </Tooltip>
                                  </>
                                ) : (
                                  el?.App_version
                                )}
                              </span>
                            )}
                          {el?.card_type === "User Post" &&
                            el?.PlatformID === 7 && (
                              <span className="mr-15 d-flex align-items-center">
                                <img
                                  src={androidImage}
                                  alt="Android Image"
                                  className="profileImg ml-1 mr-1"
                                  style={{ width: "1.5rem" }}
                                />
                                {el?.Android_version}
                              </span>
                            )}
                        </>
                      )}
                    </div>
                    {el?.card_type === "User Post" && el?.PlatformID === 7 && (
                      <span className="ml-15 mb-5 d-flex align-items-center">
                        <span className="d-flex w-100">
                          <span
                            className="text-ellipsis mr-1"
                            style={{ color: "blue" }}
                          >
                            Device Name:
                          </span>
                          <span className="text-ellipsis">{el?.Device}</span>
                        </span>
                      </span>
                    )}
                    {/* Additional for E-Commerce channel */}
                    {el?.PlatformID === 14 ? (
                      <span className="ml-15 mb-10 d-flex align-items-center">
                        <span
                          className={`w-100 ${
                            getTextDirection(el?.Title || "") === "rtl"
                              ? "d-flex justify-content-between"
                              : ""
                          }`}
                        >
                          <span
                            className={
                              authParams?.screen_id && !isDeepDiveDashboardView
                                ? "color-white"
                                : ""
                            }
                            style={{
                              flexShrink:
                                getTextDirection(el?.Title || "") === "rtl"
                                  ? 0
                                  : 1,
                            }}
                          >
                            Title :
                          </span>
                          <span
                            className={`${
                              authParams?.screen_id && !isDeepDiveDashboardView
                                ? "color-white font-weight800"
                                : "font-weight800"
                            } ${
                              getTextDirection(el?.Title || "") === "rtl"
                                ? "text-right-arabic mr-15"
                                : ""
                            }`}
                          >
                            {" "}
                            {getTextWithWrapHtml(
                              el?.Title !== "" &&
                                el?.Title !== "NA" &&
                                el?.Title
                                ? el?.Title
                                : "NA",
                              "",
                              highlightWord
                            )}
                          </span>
                        </span>
                      </span>
                    ) : (
                      ""
                    )}
                    {el?.PlatformID === 14 ? (
                      <span className="ml-15 mb-10 d-flex align-items-center">
                        <span
                          className={`w-100 ${
                            getTextDirection(el?.ProductName || "") === "rtl"
                              ? "d-flex justify-content-between"
                              : ""
                          }`}
                        >
                          <span
                            className={
                              authParams?.screen_id && !isDeepDiveDashboardView
                                ? "color-white"
                                : ""
                            }
                            style={{
                              flexShrink:
                                getTextDirection(el?.ProductName || "") ===
                                "rtl"
                                  ? 0
                                  : 1,
                            }}
                          >
                            Product Name :
                          </span>
                          <span
                            className={`${
                              authParams?.screen_id && !isDeepDiveDashboardView
                                ? "color-white font-weight800"
                                : "font-weight800"
                            } ${
                              getTextDirection(el?.ProductName || "") === "rtl"
                                ? "text-right-arabic mr-15"
                                : ""
                            }`}
                          >
                            {" "}
                            {getTextWithWrapHtml(
                              el?.ProductName !== "" &&
                                el?.ProductName !== "NA" &&
                                el?.ProductName
                                ? el?.ProductName
                                : "NA",
                              "",
                              highlightWord
                            )}
                          </span>
                        </span>
                      </span>
                    ) : (
                      ""
                    )}
                    <div
                      className={`cardList__body-description fontSize-12 mb-15 pl-15 pr-15 ${
                        getTextDirection(el?.PostText || "") === "rtl"
                          ? "text-right-arabic"
                          : ""
                      }`}
                    >
                      {el?.PostText.length > 180 ? (
                        <>
                          <div className="text_regular">
                            <a
                              className={
                                el?.PostURL &&
                                el?.PostURL?.trim() &&
                                el?.PostURL !== "NA"
                                  ? "d-block break-word pointer-events1 cursor-default"
                                  : "d-block break-word pointer-events1 cursor-default"
                              }
                              // disabling open post from text
                              // href={
                              //   el?.PostURL &&
                              //   el?.PostURL?.trim() &&
                              //   el?.PostURL !== "NA"
                              //     ? el?.PostURL
                              //     : ""
                              // }
                              rel="noreferrer"
                              target="_blank"
                            >
                              {" "}
                              {`${formatTextForDirection(
                                el?.PostText?.slice(0, 180),
                                postTextDirection
                              )}${
                                PptGeneratingStatus || PdfDownloadStatus
                                  ? "..."
                                  : ""
                              }`}
                            </a>
                            {el?.PostText?.length > 180 &&
                            !PdfDownloadStatus &&
                            !PptGeneratingStatus ? (
                              <span
                                className="blue-text cursor-pointer"
                                onClick={() => showModal(el)}
                              >
                                ... Read More
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                          {el?.Attachment?.length === 1 ? (
                            <div
                              className={`ml-15`}
                              style={
                                !PdfDownloadStatus && !PptGeneratingStatus
                                  ? { width: "10rem" }
                                  : { width: "8rem" }
                              }
                            >
                              {el?.Attachment &&
                                el?.Attachment.map((imgUrl, i) => {
                                  return imgUrl &&
                                    !PdfDownloadStatus &&
                                    !PptGeneratingStatus ? (
                                    <Image
                                      src={imgUrl}
                                      alt="Attachment Images"
                                      style={{ width: "10rem" }}
                                      fallback={defaultImg}
                                    />
                                  ) : PdfDownloadStatus ? (
                                    imgUrl && (
                                      <Image
                                        src={imgUrl}
                                        alt="Attachment Images"
                                        style={{
                                          width: "8rem",
                                          height: "7rem",
                                        }}
                                        fallback={defaultImg}
                                        preview={false}
                                        crossOrigin="anonymous"
                                      />
                                    )
                                  ) : (
                                    ""
                                  );
                                })}
                            </div>
                          ) : el?.Attachment?.length > 1 &&
                            !PdfDownloadStatus &&
                            !PptGeneratingStatus ? (
                            <div className="w-100">
                              <CarouselWidgetMaker
                                imageUrl={el?.Attachment && el?.Attachment}
                                isDeepDiveDashboardView={
                                  isDeepDiveDashboardView
                                }
                              />
                            </div>
                          ) : el?.Attachment?.[0] ? (
                            <img
                              src={
                                el?.Attachment?.[0]
                                  ? el?.Attachment?.[0]
                                  : defaultImg
                              }
                              alt="Attachment Images"
                              style={{ width: "10rem" }}
                              crossOrigin="anonymous"
                            />
                          ) : (
                            ""
                          )}
                        </>
                      ) : (
                        <>
                          <div className="text_regular break-all mb-15">
                            <a
                              className={
                                el?.PostURL &&
                                el?.PostURL?.trim() &&
                                el?.PostURL !== "NA"
                                  ? "pointer-events1 cursor-default"
                                  : "pointer-events1 cursor-default"
                              }
                              // disabling open post from text
                              // href={
                              //   el?.PostURL &&
                              //   el?.PostURL?.trim() &&
                              //   el?.PostURL !== "NA"
                              //     ? el?.PostURL
                              //     : ""
                              // }
                              target="_blank"
                              rel="noreferrer"
                            >
                              {el?.PostText}
                            </a>
                          </div>
                          {el?.Attachment?.length === 1 ? (
                            <div
                              style={{ height: "20rem" }}
                              className="m-0 w-100 text-center"
                            >
                              {el?.Attachment &&
                                el?.Attachment.map((imgUrl, i) => {
                                  return imgUrl &&
                                    !PdfDownloadStatus &&
                                    !PptGeneratingStatus ? (
                                    <Image
                                      src={imgUrl}
                                      alt="Attachment Images"
                                      fallback={defaultImg}
                                      className="w-100"
                                      style={{ height: "20rem" }}
                                    />
                                  ) : PdfDownloadStatus ? (
                                    imgUrl && (
                                      <Image
                                        src={imgUrl}
                                        alt="Attachment Images"
                                        style={{
                                          width: "8rem",
                                          height: "7rem",
                                        }}
                                        fallback={defaultImg}
                                        preview={false}
                                        crossOrigin="anonymous"
                                      />
                                    )
                                  ) : (
                                    ""
                                  );
                                })}
                            </div>
                          ) : el?.Attachment?.length > 1 &&
                            !PdfDownloadStatus &&
                            !PptGeneratingStatus ? (
                            <div className="w-100">
                              <CarouselWidgetMaker
                                imageUrl={el?.Attachment && el?.Attachment}
                                isDeepDiveDashboardView={
                                  isDeepDiveDashboardView
                                }
                              />
                            </div>
                          ) : el?.Attachment?.[0] ? (
                            <img
                              src={
                                el?.Attachment?.[0]
                                  ? el?.Attachment?.[0]
                                  : defaultImg
                              }
                              alt="Attachment Images"
                              style={{ width: "10rem" }}
                              crossOrigin="anonymous"
                            />
                          ) : (
                            ""
                          )}
                        </>
                      )}
                    </div>
                  </div>
                  <div className="d-flex justify-content-end align-items-end mb-2 mr-2">
                    {el?.PostURL &&
                    el?.PostURL?.trim() &&
                    el?.PostURL !== "NA" ? (
                      <Tooltip title="Open Post">
                        <a
                          className={`trands blue-text font-size12 cursor-pointer mr-1`}
                          href={el?.PostURL}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i
                            class={`fas fa-external-link-alt`}
                            style={{ fontSize: "1.4rem" }}
                          />
                        </a>
                      </Tooltip>
                    ) : (
                      ""
                    )}
                    {/* This is for open ticket details */}
                    {el?.TicketID && el?.TicketID !== "NA" ? (
                      <div
                        className="trands cursor-pointer mr-2"
                        onClick={() =>
                          onExternal(el?.TicketID, el?.PostBrandID)
                        }
                      >
                        <Tooltip title="Ticket Details">
                          <img
                            src={deepLinkIcon}
                            className="cardList__footer-label"
                            alt="Deep Link Icon"
                            style={{
                              maxWidth: "1.8rem",
                              width: "1.8rem",
                            }}
                          />
                        </Tooltip>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div
          className="d-flex align-items-center justify-content-center w-100"
          style={{ minHeight: "calc(100vh - 21.3rem)" }}
        >
          <div className="text-center">
            <img
              alt="no data"
              src={somethingWentWrong}
              style={{ maxWidth: "100%", minWidth: "20rem" }}
            />
            <p className="mt-15 text_regular-gray">No Data Found</p>
          </div>
        </div>
      )}

      {deepLinkModal?.modalShow && (
        <Modal
          title={null}
          visible={deepLinkModal?.modalShow}
          style={{ width: "100%", top: "1rem", paddingBottom: "1rem" }}
          onOk={handleDeepLinkOk}
          onCancel={handleDeepLinkCancel}
          width="100%"
          footer={null}
          className={`deepLinkModal ${
            authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
          }`}
        >
          {!deepLinkModal?.url ? (
            <div
              className="loader mx-auto"
              style={{ height: "calc(100vh - 2.6rem)" }}
            >
              <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          ) : (
            deepLinkModal?.url
          )}
        </Modal>
      )}
      <PostCardDetails
        data={data}
        modalData={modalData}
        isPreviewState={isPreviewState}
        PdfDownloadStatus={PdfDownloadStatus}
        PptGeneratingStatus={PptGeneratingStatus}
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        setIsModalData={setIsModalData}
        isModalLoader={isModalLoader}
        setIsModalLoader={setIsModalLoader}
        isCommandCenterScreen={false}
        isReviewCard={true}
        deepDive={deepDive}
        isDeepDiveDashboardView={isDeepDiveDashboardView}
      />
      <PaginationComponent
        data={data}
        totalPageNo={totalPageNo}
        metadata={metadata}
        section_index={section_index}
        widget_index={widget_index}
        mentionPage={mentionPage}
        pagination={pagination}
        isPreviewState={isPreviewState}
        dashboard={dashboard}
        PdfDownloadStatus={PdfDownloadStatus}
        PptGeneratingStatus={PptGeneratingStatus}
        chart_type={chart_type}
        isDeepDiveDashboardView={isDeepDiveDashboardView}
      />
    </>
  );
};

export default React.memo(ReviewCard, isEqual);
